const Actions = self => ({

  setIdleTimeout: idleTimout => {
    self.time = idleTimout;
  },

  setScriptAlreadyLoaded: isLoaded => {
    self.scriptAlreadyLoaded = isLoaded;
  },
});

export default Actions;
